import * as React from "react"
import {
  ChakraProvider,
  Box,
  theme,
} from "@chakra-ui/react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { EvmRoutes, RoutesData } from "./data/RoutesData"
import { HomePage } from "./pages/HomePage"
import { AddressPage } from "./pages/AddressPage"
import { EthereumPage } from "./pages/EthereumPage"
import { ArbNovaPage } from "./pages/ArbNovaPage"
import { CoinbasePage } from "./pages/CoinbasePage"
import { GodwokenPage } from "./pages/GodwokenPage"
import { LineaPage } from "./pages/LineaPage"
import { OpBnbPage } from "./pages/OpBnbPage"
import { PgnPage } from "./pages/PgnPage"
import { PolygonZkEvmPage } from "./pages/PolygonZkEvmPage"
import { ScrollPage } from "./pages/ScrollPage"
import { TaikoPage } from "./pages/TaikoPage"
import { ZkSyncPage } from "./pages/ZkSyncPage"
import { ZoraPage } from "./pages/ZoraPage"
import { NervosPage } from "./pages/NervosPage"
import { StarkNetPage } from "./pages/StarkNetPage"
import { StartPage } from "./pages/StartPage"
import { ConstructCirclePage } from "./pages/ConstructCirclePage"
import { EvmPage } from "./pages/ordinals/EvmPage"

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box fontSize="xl">
    <BrowserRouter>
        <Routes>
          <Route path={RoutesData.Home} element={<HomePage />} />
          <Route path={RoutesData.Start} element={<StartPage />} />
          <Route path={RoutesData.Address} element={<AddressPage />} />
          <Route path={RoutesData.OrdinalsEvm} element={<EvmPage />} />
          <Route path={RoutesData.Construct} element={<ConstructCirclePage />} />
          <Route path={EvmRoutes.ethereum.route} element={<EthereumPage />} />
          <Route path={EvmRoutes.arbNova.route} element={<ArbNovaPage />} />
          <Route path={EvmRoutes.base.route} element={<CoinbasePage />} />
          <Route path={EvmRoutes.godwoken.route} element={<GodwokenPage />} />
          <Route path={EvmRoutes.linea.route} element={<LineaPage />} />
          <Route path={EvmRoutes.opBnb.route} element={<OpBnbPage />} />
          <Route path={EvmRoutes.pgn.route} element={<PgnPage />} />
          <Route path={EvmRoutes.polygonZkEvm.route} element={<PolygonZkEvmPage />} />
          <Route path={EvmRoutes.scroll.route} element={<ScrollPage />} />
          <Route path={EvmRoutes.taiko.route} element={<TaikoPage />} />
          <Route path={EvmRoutes.zksync.route} element={<ZkSyncPage />} />
          <Route path={EvmRoutes.zora.route} element={<ZoraPage />} />
          <Route path={RoutesData.Nervos} element={<NervosPage />} />
          <Route path={RoutesData.StarkNet} element={<StarkNetPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </Box>
  </ChakraProvider>
)
